import { EXTEND_SKU } from '@/data/constants/EXTEND_SKU'

export const checkIsExtendItem = (variant: { sku: string }) => `${variant.sku}`.includes(EXTEND_SKU)

export default checkIsExtendItem
